import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles({
  buttonRed: {
    color: "#ffffff",
    border: "solid 1px",
    background: "#B00020",
    "&:hover": { color: "#B00020", background: "#ffffff" },
  },
});

export default function ConfirmDialog({
  body,
  open,
  handleClick,
  handleClickOut,
  buttonOneText,
  buttonTwoText,
  disabled,
  showDetail
}) {
  const classes = useStyles();
  return (
    <Dialog
      fullWidth={true}
      maxWidth={showDetail ? 'lg': 'md' }
      open={open}
      onClose={handleClickOut}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent style={{ backgroundColor: "#B00020" }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <DialogContentText
              id="alert-dialog-description"
              style={{ color: "#ffffff", textAlign: "center" }}
            >
              {body}
            </DialogContentText>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={handleClick}
              className={classes.buttonRed}
              variant="contained"
              autoFocus
              style={{ width: "229px", marginRight: "10px" }}
            >
              {buttonOneText ? buttonOneText : "ACEPTAR"}
            </Button>
            <Button
              disabled={disabled}
              onClick={handleClickOut}
              className={classes.buttonRed}
              variant="contained"
              style={{ marginRight: "10px" }}
            >
              {buttonTwoText ? buttonTwoText : "CANCELAR"}
            </Button>
            {showDetail ?
            <Button
              disabled={disabled}
              onClick={showDetail}
              className={classes.buttonRed}
              variant="contained"
            >
              {buttonTwoText ? buttonTwoText : "VER HOJA DE VIDA"}
            </Button>
            : null
            }
          </Grid>
        </Grid>
      </DialogContent>
      {/* <DialogActions style={{ backgroundColor: "#B00020" }}>
        
      </DialogActions> */}
    </Dialog>
  );
}
